import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalTables } from '../../../models'
import { genericMetricHeaders } from './generic-metric-headers'

export const genericAdgroupSearchMetricHeaders: Array<TGlobalTables> =
  genericMetricHeaders.filter(
    (header) =>
      !(
        header === EReportColumnHeader.ShareOfVoice ||
        header === EReportColumnHeader.WinRate
      )
  )
